<template>
  <div class="ac-card-content">
    <div
      style="align-items:baseline;"
      class="ac-header-container"
    >
      <div class="ac-header">
        Add New Hub Address
        <div style="padding: 5px 0px; font-size: .85rem; color:#5A637D;">
          <div class="ac-input-header">
            Address created will be set as default installed address
          </div>
        </div>
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-sub-container">
        <!-- Hub Address Update -->
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Address
        </div>
        <SACInput
          :value="address1"
          class="margin-bottom"
          field="address1"
          placeholder="Enter Street Address"
          :change="handleChange"
        />
        <SACInput
          :value="address2"
          class="margin-bottom"
          field="address2"
          placeholder="Enter Apt #, Suite #, etc"
          :change="handleChange"
        />
      </div>
      <div class="ac-body-sub-container">
        <SACInput
          :value="city"
          class="margin-bottom"
          field="city"
          placeholder="Enter City"
          :change="handleChange"
        />
        <SACDropdown
          class="margin-bottom"
          :options="states"
          :value="state"
          optionLabel="state"
          optionValue="abbreviation"
          placeholder="Select State"
          field="state"
          :change="handleChange"
        />
        <SACInput
          :value="zip"
          field="zip"
          placeholder="Enter Zip"
          :change="handleChange"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="createAddress"
      >
        Create
      </button>
    </div>
    <ProcessOverlay
      :show="infoEditing"
      text="Updating Hub Address"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'HubAddressUpdate',
  components: {
    SACInput,
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
    };
  },
  methods: {
    handleChange(field, value) {
      if (field === 'address') {
        Object.keys(value).forEach((key) => {
          this[key] = value[key];
        });
      } else {
        this[field] = value;
      }
    },
    createAddress() {
      const {
        address1,
        address2,
        city,
        state,
        zip,
      } = this;
      this.$store.dispatch('createNewServiceAddress', {
        address1,
        address2,
        city,
        state,
        zip,
      });
    },
  },
};
</script>
